import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTwitter, FaFacebook, FaYoutube, FaTiktok } from 'react-icons/fa';

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand and Description */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold text-black">RigidAthlete</h3>
            <p className="text-black text-sm">
              Your personal fitness journey starts here. Track, improve, and achieve your goals.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-black uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-black hover:text-gray-700 text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-black hover:text-gray-700 text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-black hover:text-gray-700 text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-black hover:text-gray-700 text-sm">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-sm font-semibold text-black uppercase tracking-wider mb-4">
              Follow Us
            </h4>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/rigidathlete"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-gray-700"
              >
                <FaInstagram className="h-6 w-6" />
              </a>
              <a
                href="https://twitter.com/rigid_athlete"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-gray-700"
              >
                <FaTwitter className="h-6 w-6" />
              </a>
              <a
                href="https://facebook.com/rigidathlete"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-gray-700"
              >
                <FaFacebook className="h-6 w-6" />
              </a>
              <a
                href="https://youtube.com/@rigidathlete"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-gray-700"
              >
                <FaYoutube className="h-6 w-6" />
              </a>
              <a
                href="https://tiktok.com/@rigidathlete"
                target="_blank"
                rel="noopener noreferrer"
                className="text-black hover:text-gray-700"
              >
                <FaTiktok className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-black">
          <p className="text-center text-black text-sm">
            © {new Date().getFullYear()} RigidAthlete. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};